// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareLinkStyles } from "@sc/Overrides/Widgets/ProductDetails/ProductDetailsShareLink";
import Email from "@sc/XDL/Icons/Email";
import Print from "@sc/XDL/Icons/Print";
import { createLinkIconStyles } from "@sc/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

shareLinkStyles.wrapper = {
    css: css`
        display: flex;
        gap: 24px;
        margin-bottom: 16px;
    `,
};

shareLinkStyles.printLink = {
    ...createLinkIconStyles(Print, {
        icon: {
            iconProps: {
                css: css`
                    &,
                    svg {
                        width: 12px;
                    }
                `,
            },
        },
    }),
};

shareLinkStyles.link = {
    link: {
        ...createLinkIconStyles(Email, {
            icon: {
                iconProps: {
                    css: css`
                        &,
                        svg {
                            width: 12px;
                        }
                    `,
                },
            },
        }),
    },
};
